<!-- main body -->
<div class="row">

  <div class="col-xl-12 mb-30">
    <div class="card card-statistics">
      <div class="card-body">
       <h5 class="card-title">Behfa Rules</h5>
       <div class="accordion gray plus-icon round">
          <div  class="acd-group" *ngFor="let item of DataList_Behfa" (click)="ChangeItem(item)" [ngClass]="{'acd-active': item.del!=false}">
              <a style="cursor: pointer;" class="acd-heading">{{item.title}}</a>
              <div *ngIf="item.del!=false" class="acd-des" innerHTML="{{item.dsc}}"></div>
          </div>
      </div>
      </div>
    </div>
  </div>


</div>
